var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import './KodanshaCart.scss';
import { Link } from 'react-router-dom';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { AddToCartAction, DeductFromCartAction, FetchCartAtom, RemoveAllOfProductFromCartAction, ShowCartAtom, } from '../../store/CartStore';
import { Cart } from '../../Models/Cart';
import { CheckoutOverlayVisible, LoginOverlayVisible, LoginType, LoginTypeStore } from '../../store/OverlayStore';
import { ReactComponent as CancelIcon, ReactComponent as PlusIcon } from '../Assets/icons/PLUS.svg';
import { ReactComponent as ArrowIcon } from '../Assets/icons/buttonArrow.svg';
import { ReactComponent as MinusIcon } from '../Assets/icons/MINUS.svg';
import { VariantType } from '../../Models/CartItem';
import { showScroll } from '../../utils/utils';
import InkyMageImg from '../../Devon/Components/InkyMageImg/InkyMageImg';
import { LoginStatusAtom } from '../../store/AccountStore';
export function ShowCartItems(_a) {
    var _b;
    var CloseCarts = _a.CloseCarts, _c = _a.isScrollable, isScrollable = _c === void 0 ? true : _c, _d = _a.fromSuccessCheckout, fromSuccessCheckout = _d === void 0 ? false : _d;
    var cartAnyType = useAtomValue(FetchCartAtom);
    // Hack to fix types. Remove this when we are in TS strict-mode.
    var cart = cartAnyType;
    // No cart
    if (!cart) {
        return null;
    }
    // No items in cart
    if (((_b = cart.cartItems) === null || _b === void 0 ? void 0 : _b.length) === 0) {
        return (_jsx("h3", { className: 'no-items-in-cart', children: "No items in cart" }));
    }
    return _jsx(React.Fragment, { children: _jsx(ShowProductList, { cartItems: cart.cartItems, isScrollable: isScrollable, CloseCarts: CloseCarts, fromSuccessCheckout: fromSuccessCheckout }) });
}
var ShowProductList = function (_a) {
    var _b = _a.isScrollable, isScrollable = _b === void 0 ? true : _b, _c = _a.fromSuccessCheckout, fromSuccessCheckout = _c === void 0 ? false : _c, cartItems = _a.cartItems;
    var _d = __read(useAtom(RemoveAllOfProductFromCartAction), 2), removeFromCart = _d[1];
    var _e = __read(useAtom(DeductFromCartAction), 2), deductFromCartAction = _e[1];
    var _f = __read(useAtom(AddToCartAction), 2), addToCartAction = _f[1];
    var _g = __read(useAtom(ShowCartAtom), 2), showCart = _g[0], setShowCart = _g[1];
    var _h = __read(useAtom(CheckoutOverlayVisible), 2), checkoutOverlayVisible = _h[0], setCheckoutOverlayVisible = _h[1];
    var uniqueCartItems = [];
    cartItems === null || cartItems === void 0 ? void 0 : cartItems.forEach(function (item) {
        if (!uniqueCartItems.find(function (x) { return x.product.id == item.product.id && x.variant.id == item.variant.id; })) {
            uniqueCartItems.push(item);
        }
    });
    function findAmount(productID, variantId) {
        return cartItems.filter(function (x) { return x.product.id == productID && x.variant.id == variantId; }).length;
    }
    function getTotalPriceForProduct(productID, variantId, price) {
        return price.multiply(findAmount(productID, variantId));
    }
    function isLessThanOrderAmountIfOrderAmount(cartItem) {
        return !(cartItem.variant.cartLimit === undefined ||
            cartItem.variant.cartLimit === null ||
            findAmount(cartItem.product.id, cartItem.variant.id) < cartItem.variant.cartLimit);
    }
    return _jsx("div", { className: 'cart-items-content', style: {
            overflowY: isScrollable ? 'auto' : 'hidden', maxHeight: isScrollable ? '40vh' : 'unset',
            minHeight: isScrollable && '116px',
        }, children: uniqueCartItems.map((function (cartItem, index) {
            var _a, _b;
            return _jsxs("div", { className: "cart-item ".concat(index === 0 && 'cart-item-first', " ").concat(fromSuccessCheckout && 'cart-item-success'), children: [_jsx(Link, { onClick: function () {
                            if (showCart) {
                                setShowCart(false);
                            }
                            if (checkoutOverlayVisible) {
                                setCheckoutOverlayVisible(false);
                            }
                        }, to: '/product/' + cartItem.product.id.toString(), className: 'thumbnail', children: _jsx(InkyMageImg, { src: (_b = (_a = cartItem.product) === null || _a === void 0 ? void 0 : _a.thumbnails[0]) === null || _b === void 0 ? void 0 : _b.url, alt: 'cover for ' + cartItem.product.name, className: 'cart-item-thumbnail', s: { width: 60 }, m: { width: 60 }, l: { width: 60 }, xl: { width: 60 } }) }), _jsxs(Link, { onClick: function () {
                            console.log("yeef", showCart);
                            if (showCart) {
                                setShowCart(false);
                            }
                            if (checkoutOverlayVisible) {
                                setCheckoutOverlayVisible(false);
                            }
                        }, to: '/product/' + cartItem.product.id.toString(), className: 'metadata', children: [_jsx("span", { className: 'distribution-type', children: cartItem.distributionType }), _jsx("h3", { children: cartItem.product.name })] }), _jsxs("div", { className: "amount-cart ".concat(cartItem.distributionType === VariantType.Print && 'amount-cart-physical'), children: [cartItem.distributionType === VariantType.Print && _jsx("button", { className: "button-no-style ".concat(findAmount(cartItem.product.id, cartItem.variant.id) === 1 ? "button-no-style-no-hover" : ""), style: { fill: findAmount(cartItem.product.id, cartItem.variant.id) === 1 ? 'grey' : '' }, onClick: function (e) {
                                    e.preventDefault();
                                    if (findAmount(cartItem.product.id, cartItem.variant.id) === 1) {
                                        return;
                                    }
                                    deductFromCartAction({ productId: cartItem.product.id, variantId: cartItem.variant.id });
                                }, children: _jsx(MinusIcon, { width: 15 }) }), _jsx("span", { className: 'quantity', children: findAmount(cartItem.product.id, cartItem.variant.id) }), cartItem.distributionType === VariantType.Print
                                &&
                                    _jsx("button", { className: "button-no-style ".concat(isLessThanOrderAmountIfOrderAmount(cartItem) ? "button-no-style-no-hover" : ""), onClick: function (e) {
                                            e.preventDefault();
                                            addToCartAction({ productId: cartItem.product.id, variantId: cartItem.variant.id });
                                        }, style: { fill: (isLessThanOrderAmountIfOrderAmount(cartItem)) ? 'grey' : "" }, disabled: isLessThanOrderAmountIfOrderAmount(cartItem), children: _jsx(PlusIcon, { width: 15 }) })] }), _jsxs("div", { className: 'price', children: [getTotalPriceForProduct(cartItem.product.id, cartItem.variant.id, cartItem.price).toFormat(), " ", cartItem.isOnSale && (_jsx("span", { children: getTotalPriceForProduct(cartItem.product.id, cartItem.variant.id, cartItem.fullPrice).toFormat() }))] }), !fromSuccessCheckout && _jsx("div", { className: 'actions', children: _jsx("button", { "aria-label": 'remove-from-cart', className: 'button-no-style', onClick: function (e) {
                                e.preventDefault();
                                removeFromCart({ productId: cartItem.product.id, variantId: cartItem.variant.id });
                            }, children: _jsx(CancelIcon, { width: 20, className: 'cart-item-cancel-icon' }) }) })] }, index);
        })) });
};
export var ShowCartItemsTitle = function (_a) {
    var _b = _a.fromSuccessCheckout, fromSuccessCheckout = _b === void 0 ? false : _b;
    return _jsx(React.Fragment, { children: _jsxs("div", { className: "cart-headers ".concat(fromSuccessCheckout && 'cart-headers-success'), children: [_jsx("span", { className: 'cart-header-one', style: { color: fromSuccessCheckout && '#000000' }, children: "Product" }), _jsx("span", { className: '' }), _jsx("span", { className: 'cart-header-two', style: { color: fromSuccessCheckout && '#000000' }, children: "Quantity" }), _jsx("span", { className: 'cart-header-three', style: { color: fromSuccessCheckout && '#000000' }, children: "Price" })] }) });
};
export function KodanshaCart(_a) {
    var _b, _c;
    var CloseCarts = _a.CloseCarts;
    var _d = __read(useAtom(ShowCartAtom), 2), showCart = _d[0], setShowCart = _d[1];
    var _e = __read(useAtom(LoginStatusAtom), 1), isLoggedIn = _e[0];
    var cartAnyType = useAtomValue(FetchCartAtom);
    var SetLoginOverlay = useSetAtom(LoginOverlayVisible);
    // Checkout actions
    var _f = __read(useAtom(CheckoutOverlayVisible), 2), setCheckoutOverlay = _f[1];
    // Hack to fix types. Remove this when we are in TS strict-mode.
    var cart = cartAnyType;
    function showTotal() {
        var _a;
        if (!cart)
            return;
        if (((_a = cart.cartItems) === null || _a === void 0 ? void 0 : _a.length) == 0)
            return null;
        return (_jsxs("div", { className: 'total-cart', children: [_jsxs("div", { className: 'subtotal', children: [_jsx("span", { className: 'label-cart', children: "Subtotal" }), _jsx("span", { className: 'value', children: Cart.getCartTotal(cart).toFormat() })] }), _jsx("div", { className: 'disclaimer cart-tax', children: "Taxes Determined at checkout" })] }));
    }
    function showCheckoutCTA() {
        var _a;
        if (!cart)
            return;
        if (((_a = cart.cartItems) === null || _a === void 0 ? void 0 : _a.length) == 0)
            return;
        return (_jsxs("div", { className: 'cart-checkout', onClick: function (e) {
                e.preventDefault();
                if (isLoggedIn === "LoggedIn") {
                    setCheckoutOverlay(true);
                    setShowCart(false);
                }
                else {
                    SetLoginOverlay(true);
                    setShowCart(false);
                    LoginTypeStore.setLoginType(LoginType.Checkout);
                }
            }, children: [_jsx(Link, { onClick: function (e) { return e.preventDefault(); }, to: '#', children: "Checkout" }), _jsx(ArrowIcon, { fill: 'white' })] }));
    }
    return (_jsx("div", { className: 'KodanshaCart', onClick: function (e) {
            e.stopPropagation();
            showScroll();
            setShowCart(false);
        }, children: _jsxs("div", { className: 'cart-section', onClick: function (e) { return e.stopPropagation(); }, children: [((_b = cart.cartItems) === null || _b === void 0 ? void 0 : _b.length) !== 0 && _jsx("span", { className: 'cart-order-title', children: "Cart Order" }), ((_c = cart.cartItems) === null || _c === void 0 ? void 0 : _c.length) !== 0 && _jsx(ShowCartItemsTitle, {}), _jsx(ShowCartItems, { CloseCarts: CloseCarts }), showTotal(), showCheckoutCTA(), _jsx("div", { className: 'cart-cta', onClick: function (e) {
                        e.preventDefault();
                        showScroll();
                        setShowCart(!showCart);
                    }, children: _jsx("button", { "aria-label": 'continue-shopping', children: "Continue Shopping" }) })] }) }));
}
